import React, { FC } from 'react'
import { useDispatch } from 'react-redux'
import { editorAddDuration, editorDeleteDuration, editorUpdateDuration, editorUpdateLabel } from '../../../../../../store/pages-management/actions'
import { DurationsProps as Props } from './types'
import bin from '../../../../../../assets/img/bin.png'
 
const Durations: FC<Props> = ({ strings, field }) => {
  // REDUX STORE
  const dispatch = useDispatch()

  return (
    <div className="part durations">
      <div className="part_header">
        <h3 className="inline">{ strings.duration }</h3>
        <button
          className="button is-primary inline float-right"
          onClick={ () => dispatch(editorAddDuration()) }
        >
          <i className="fa fa-plus" />
          { ' ' + strings.add_duration }
        </button>
      </div>

      { field.durations?.map((duration, index, durations) => (
        <div className="duration columns" key={ index }>
          <div className="column is-5">
            <label>{ strings.label }</label>
            <input
              type="text"
              className="grey full-width"
              value={ duration.label }
              onChange={ (e) => dispatch(editorUpdateLabel(index, e.target.value)) }
            />
          </div>

          <div className="column is-5">
            <label>{ strings.duration }</label>
            <select
              className="grey full-width"
              value={ duration.duration }
              style={{
                margin: '5px 0',
                height: '45px',
              }}
              onChange={ (e) => dispatch(editorUpdateDuration(index, Number(e.target.value))) }
              onBlur={ (e) => (e.target.value === '' || !e.target.value) && dispatch(editorUpdateDuration(index, 15)) }
            >
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
              <option value={30}>30</option>
              <option value={45}>45</option>
              <option value={60}>1h</option>
              <option value={75}>1h15</option>
              <option value={90}>1h30</option>
              <option value={105}>1h45</option>
              <option value={120}>2h</option>
              <option value={180}>3h</option>
              <option value={240}>4h</option>
              <option value={480}>8h</option>
            </select>
          </div>
          <div className="column is-2 imgDiv">
            { durations.length > 1 &&
              <img
                src={ bin }
                alt={ strings.delete_duration }
                onClick={() => dispatch(editorDeleteDuration(duration.duration)) }
                role="presentation"
              />
            }
          </div>
        </div>
      ))}
    </div>
  )
}
 
export default Durations
 